export const API_URL = 'https://kind-erin-pike-tux.cyclic.cloud/api'